import PropTypes from "prop-types"
import { Grid2 as Grid } from "@mui/material"
import classNames from "classnames"
import ResourceTooltipInfo from "components/resource-tooltip-info"
import { useAccountAlias } from "resources/account"
import { useResourceComponentLink } from "./hooks/use-resource-component-link"
import { DashboardButton, getDashboardInstrumentUrl } from "./buttons"

export default function ResourceName({ resource, hasModels, openBasket, isHovering }) {
  const { shortType } = resource
  const account = useAccountAlias()
  const { component } = useResourceComponentLink(resource, hasModels, openBasket)

  return <Grid container className="name-container" alignItems="stretch">
    <Grid className={classNames("name", { hover: isHovering })}>{component}</Grid>
    <Grid className="tooltip"><ResourceTooltipInfo {...resource} /></Grid>
    {isHovering && shortType === "p" && <Grid className="tooltip"><DashboardButton to={getDashboardInstrumentUrl(account, resource.type || "portfolio", resource.alias || resource.id)} /></Grid>}
  </Grid>
}

ResourceName.propTypes = {
  resource: PropTypes.object.isRequired,
  hasModels: PropTypes.bool.isRequired,
  openBasket: PropTypes.func.isRequired,
  isHovering: PropTypes.bool,
}
